// extracted by mini-css-extract-plugin
module.exports = {"author":"Author_author__1VqKq","authorRss":"Author_authorRss__3_nUl","author_image":"Author_author_image__1paR2","level":"Author_level__RiUXI"};